import React from "react";
import "./RefMenu.scss";
import { NavLink } from "react-router-dom";
import logo from "../../../../Assets/General/Img/logo_nets.svg";
const RefMenu = ({menuLink}) => {
  return (
    <div className="refMenu_container">
      <div className="refMenu_block">
        <NavLink to={'/'} >
        <img src={logo} alt="" />
        </NavLink>
        <div className="refMenu_item">
          {
            menuLink?.map((e)=> 
              e.vps ? <NavLink to={e.link}>{e.name}</NavLink> : <a href={e.link} key={e.id}>{e.name}</a>
            )
          }
           
        </div>
      </div>
      <div className="refMenuSearch_block">
        {/* <div className="refMenuSearch_item">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <g clip-path="url(#clip0_226_1632)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.761883 8.47833C0.90205 6.76426 0.972132 5.90723 1.66868 4.64388C2.13884 3.79113 3.4604 2.46956 4.31316 1.9994C5.57651 1.30285 6.43354 1.23277 8.1476 1.0926C8.99143 1.0236 9.86878 0.980713 10.7461 0.980713C11.6236 0.980713 12.5009 1.0236 13.3447 1.0926C15.0587 1.23277 15.9158 1.30285 17.1791 1.9994C18.0319 2.46956 19.3535 3.79113 19.8236 4.64388C20.5202 5.90723 20.5903 6.76426 20.7304 8.47833C20.7994 9.32215 20.8423 10.1995 20.8423 11.0769C20.8423 11.9543 20.7994 12.8316 20.7304 13.6754C20.5903 15.3895 20.5202 16.2465 19.8236 17.5098C19.7284 17.6826 19.5982 17.8746 19.444 18.0748L24.3388 22.9662C24.5747 23.2021 24.692 23.5114 24.6909 23.8205C24.6898 24.1267 24.5724 24.4324 24.3388 24.666C24.1075 24.8973 23.8054 25.0147 23.5021 25.0179C23.1902 25.0214 22.8771 24.9041 22.6391 24.666L17.7443 19.7747C17.5439 19.9289 17.3519 20.0591 17.1791 20.1544C15.9158 20.8509 15.0587 20.921 13.3447 21.0611C12.5009 21.1301 11.6236 21.173 10.7461 21.173C9.86878 21.173 8.99143 21.1301 8.14761 21.0611C6.43354 20.921 5.57651 20.8509 4.31316 20.1544C3.46041 19.6842 2.13884 18.3626 1.66868 17.5098C0.972132 16.2465 0.90205 15.3895 0.761883 13.6754C0.692881 12.8316 0.649994 11.9543 0.649994 11.0769C0.649994 10.1995 0.692881 9.32215 0.761883 8.47833ZM8.34352 3.48845C9.13455 3.42377 9.94551 3.38456 10.7461 3.38456C11.5468 3.38456 12.3578 3.42377 13.1487 3.48845C14.8679 3.62903 15.2521 3.68192 16.0186 4.10448C16.1581 4.18145 16.5164 4.44933 16.9451 4.87794C17.3736 5.30656 17.6415 5.66491 17.7186 5.80451C18.1411 6.57092 18.194 6.95513 18.3346 8.67424C18.3992 9.46527 18.4385 10.2762 18.4385 11.0769C18.4385 11.8775 18.3992 12.6885 18.3346 13.4795C18.194 15.1986 18.1411 15.5828 17.7186 16.3493C17.6415 16.4888 17.3736 16.8472 16.9451 17.2758C16.5164 17.7044 16.1581 17.9723 16.0186 18.0493C15.2521 18.4718 14.8679 18.5248 13.1487 18.6653C12.3578 18.7299 11.5468 18.7692 10.7461 18.7692C9.94551 18.7692 9.13455 18.7299 8.34352 18.6653C6.62441 18.5248 6.24021 18.4718 5.47379 18.0493C5.33419 17.9723 4.97584 17.7044 4.54722 17.2758C4.11861 16.8472 3.85073 16.4888 3.77376 16.3493C3.35121 15.5828 3.29831 15.1986 3.15773 13.4795C3.09305 12.6885 3.05384 11.8775 3.05384 11.0769C3.05384 10.2762 3.09305 9.46527 3.15773 8.67424C3.29831 6.95513 3.35121 6.57092 3.77376 5.80451C3.85073 5.66491 4.11861 5.30656 4.54722 4.87794C4.97584 4.44933 5.33419 4.18145 5.47379 4.10448C6.24021 3.68192 6.62441 3.62903 8.34352 3.48845Z"
              fill="#969FA8"
            />
          </g>
          <defs>
            <clipPath id="clip0_226_1632">
              <rect
                width="25"
                height="25"
                fill="white"
                transform="translate(0.649994 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        <p>
        Поиск
        </p>
        </div> */}
        <NavLink to={'/login'}><button>Войти</button></NavLink>
      </div>
    </div>
  );
};

export default RefMenu;
